import React from 'react';
import { Theme } from '../../Enums/Theme.enum';
import LinkButton from './LinkButton';
// @ts-ignore
import styles from './Buttons.module.scss';

interface Props {
	onClick: () => void;
	title?: string;
}

const ReplyButton: React.FC<Props> = ({ onClick, title = 'base.respond' }) => {
	return (
		<div className={styles.attachmentButton}>
			<img
				className={styles.icon}
				src={'/dist/icons/v2/reply.svg'}
				alt={'reply'}
			/>
			<LinkButton onClick={onClick} title={title} theme={Theme.BLUE} />
		</div>
	);
};

export default ReplyButton;
